import { PdTimelineWizard } from "./pd-timeline-wizard/PdTimelineWizard.js";
//#region src/pd-timeline-wizard/pd-timeline-wizard.ts
var tag = "pd-timeline-wizard";
if (!customElements.get(tag)) customElements.define(tag, PdTimelineWizard);
//#endregion
export { PdTimelineWizard };
